var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ability-detail"},[_c('h4',{staticClass:"page-title my-3"},[_vm._v(_vm._s(_vm.form.name))]),_c('el-card',[_c('target-detail',{attrs:{"form":_vm.form}}),_c('div',{staticClass:"text-center"},[_c('el-button',{attrs:{"type":"primary","size":"medium"},on:{"click":_vm.handleBack}},[_vm._v("返回")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }